import React from 'react';
import { tA11y } from '@utils/a11y/a11yHelpers';
import { appButtonType, appIconsPath, validCharRegex } from '@utils/globalConstant';
import { Form, Formik } from 'formik';
import {
  FormInputField,
  ButtonPrimary,
  FormDatePicker,
  FocusFirstError,
  DuetDatePicker
} from '@core/index';
import { useActivation } from '@context/MobileOne';
import { PersonalDataLayout } from './PersonalDataLayout';
import moment from 'moment';

export function PersonalData() {
  const { setStep7SubStep, personalDataForm, setPersonalDataForm, personalDataValidations } =
    useActivation();

  // Const
  const buttonContent = tA11y('ek_reg_brthdy_btn1');
  const step7SubStep0Schema = personalDataValidations.pick(['firstName', 'lastName', 'birthDate']);
  const today = new Date();
  const minDate = new Date(today.setFullYear(today.getFullYear() - 16));
  const minDateString = minDate.toISOString().split('T')[0];

  return (
    <PersonalDataLayout
      titleKey="ek_reg_prsnl_data_hdl1"
      formTitleKey="ek_reg_prsnl_data_hdl2"
      icon={appIconsPath.KONTO_ACTIVE_NO}>
      <div className="w-100 pt-32">
        <Formik
          initialValues={personalDataForm}
          validationSchema={step7SubStep0Schema}
          onSubmit={(val) => {
            setPersonalDataForm({ ...personalDataForm, ...val });
            setStep7SubStep(1);
          }}>
          {({
            values: { firstName, lastName, birthDate },
            handleBlur,
            handleChange,
            handleSubmit,
            setFieldValue,
            touched,
            errors
          // eslint-disable-next-line arrow-body-style
          }) => {
            // BFSG: remove console log
            // console.log(errors);
            return (
              <Form onSubmit={handleSubmit}>
                <FormInputField
                  label="ek_global_name_lbl"
                  placeholder="ek_global_name_plc"
                  type="text"
                  id="firstName"
                  name="firstName"
                  value={firstName}
                  onChange={handleChange}
                  onClear={setFieldValue}
                  onBlur={handleBlur}
                  valid={touched.firstName && !errors.firstName}
                  invalid={touched.firstName && errors.firstName}
                  invalidMessage={touched.firstName && errors.firstName ? errors.firstName : null}
                  aria-describedby="firstName-error"
                  checkCharRegex={validCharRegex.FIRST_NAME}
                />
                <FormInputField
                  customClass="mt-32 mb-32"
                  label="ek_global_surname_lbl"
                  placeholder="ek_global_surname_plc"
                  type="text"
                  id="lastName"
                  name="lastName"
                  value={lastName}
                  onChange={handleChange}
                  onClear={setFieldValue}
                  onBlur={handleBlur}
                  valid={touched.lastName && !errors.lastName}
                  invalid={touched.lastName && errors.lastName}
                  invalidMessage={touched.lastName && errors.lastName ? errors.lastName : null}
                  aria-describedby="lastName-error"
                  checkCharRegex={validCharRegex.LAST_NAME}
                />
                {/* <FormDatePicker
                  id="id"
                  value={birthDate}
                  name="birthDate"
                  label="ek_global_brthdy_lbl"
                  placeholder="ek_global_brthdy_plc"
                  onChange={(date) => setFieldValue('birthDate', date)}
                  onBlur={handleBlur}
                  valid={touched.birthDate && !errors.birthDate}
                  invalid={touched.birthDate && errors.birthDate}
                  invalidMessage={touched.birthDate && errors.birthDate ? errors.birthDate : null}
                  aria-describedby="birthDate-error"
                /> */}
                <DuetDatePicker
                  value={birthDate}
                  onChange={(e) => {
                    setFieldValue('birthDate', moment(e.detail.valueAsDate).format('DD.MM.YYYY'))
                  }}
                  label={'ek_global_brthdy_lbl'}
                  id="birthDate"
                  name="birthDate"
                  min="1900-01-01"
                  max={`${minDateString}`}
                  placeholder={'ek_global_brthdy_plc'}
                  ariaDescribedby="birthDate-error"
                  onBlur={handleBlur}
                  valid={touched.birthDate && !errors.birthDate}
                  invalid={!!touched.birthDate && !!errors.birthDate}
                  invalidMessage={
                    touched.birthDate && errors.birthDate ? errors.birthDate : null
                  }
                  identifier="birthDate-input"
                />
                <div className="row">
                  <div className="col-xxl-5 col-lg-5 col-10 px-0 mx-auto">
                    <ButtonPrimary
                      buttonClass="my-40"
                      buttonType={appButtonType.PRIMARY}
                      buttonContent={buttonContent}
                      iconRight={appIconsPath.ARROW_RIGHT}
                      type="submit"
                    />
                  </div>
                </div>
                <FocusFirstError />
              </Form>
            );
          }}
        </Formik>
      </div>
    </PersonalDataLayout>
  );
}

export default PersonalData;
